<template>
  <div class="bottom-tab">
      <div
      class="tab-item" 
      v-for="(item, index) in tabList"
      :key="item.path"
      :class="{ active: activeIndex === index }"
      @click="handleTabClick(item, index)"
    >
      <!-- 图标 -->
      <svg class="tab-icon" viewBox="0 0 24 24" fill="none" :stroke="activeIndex === index ? '#165DFF' : '#999'" stroke-width="2">
        <path v-if="item.name === '活动赛事'" d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline v-if="item.name === '活动赛事'" points="9 22 9 12 15 12 15 22"></polyline>

        <rect v-if="item.name === '申请加入'" x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <line v-if="item.name === '申请加入'" x1="12" y1="8" x2="12" y2="16"></line>
        <line v-if="item.name === '申请加入'" x1="8" y1="12" x2="16" y2="12"></line>

        <path v-if="item.name === '供需链接'" d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
        <path v-if="item.name === '供需链接'" d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>

        <path v-if="item.name === '我的'" d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle v-if="item.name === '我的'" cx="12" cy="7" r="4"></circle>
      </svg>
      <!-- 文字 -->
      <span class="tab-text">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomTab',
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tabList: [
        { name: '活动赛事', path: '/activity' },
        { name: '申请加入', path: '/apply' },
        { name: '供需链接', path: '/supply-demand' },
        { name: '我的', path: '/mine' }
      ]
    }
  },
  methods: {
    handleTabClick(item, index) {
      this.$emit('tab-change', index, item.path)
    }
  }
}
</script>

<style scoped>
.bottom-tab {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 30;
  display: flex;
  justify-content: space-around;
  background: #fff;
  padding: 10px 0;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #999;
  font-size: 12px;
  cursor: pointer;
}

.tab-item.active {
  color: #165DFF;
}

.tab-icon {
  width: 24px;
  height: 24px;
}

.tab-text {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/BottomTab.vue